import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Modal } from "@faire/web--source/slate/Modal";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { useQuery as useTeamMembersQuery } from "@faire/web-api--source/api/retailer/team-members/get-hooks";
import { trackRetailerTeamManagementMultiUserHomepageTeamModalCtaClick } from "@faire/web-api--source/events/retailerTeamManagement/click/multiUserHomepageTeamModalCta";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import myTeamRoute from "@faire/web-api--source/routes/www/retailer/settings/my-team";
import React from "react";
import styled from "styled-components";
export var TeamMembersModal = function(param) {
    var onClose = param.onClose;
    var _useTeamMembersQuery = useTeamMembersQuery(), data = _useTeamMembersQuery.data, isLoading = _useTeamMembersQuery.isPending;
    var _data_team_members_data;
    return /*#__PURE__*/ _jsxs(StyledModal, {
        "data-test-id": "homepage-banner-team-members-modal",
        align: "flex-start",
        padding: "88px 24px 24px 24px",
        onClose: onClose,
        width: "400px",
        height: "490px",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "gLCvI3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Team members"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            isLoading ? /*#__PURE__*/ _jsx(LoadingSpinnerWrapper, {
                children: /*#__PURE__*/ _jsx(LoadingSpinner, {})
            }) : /*#__PURE__*/ _jsx(TeamMembersWrapper, {
                align: "flex-start",
                children: ((_data_team_members_data = data === null || data === void 0 ? void 0 : data.team_members_data) !== null && _data_team_members_data !== void 0 ? _data_team_members_data : []).map(function(teamMember, index) {
                    return /*#__PURE__*/ _jsxs(TeamMemberRow, {
                        children: [
                            /*#__PURE__*/ _jsx(Avatar, {
                                image: IImage.build({
                                    url: teamMember.image_url
                                }),
                                size: "smaller"
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "2x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansMedium",
                                children: teamMember.title
                            })
                        ]
                    }, "team-member-title-".concat(teamMember.title, "-").concat(index));
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(ViewTeamButton, {
                linkTo: myTeamRoute(),
                onClick: trackRetailerTeamManagementMultiUserHomepageTeamModalCtaClick,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "NSWdMK",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "View team page"
                        }
                    ]
                })
            })
        ]
    });
};
var LoadingSpinnerWrapper = styled(Column).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-1733847e-0"
})([
    "width:100%;height:225px;"
]);
var StyledModal = styled(Modal).withConfig({
    componentId: "sc-1733847e-1"
})([
    "",
    "{height:auto !important;position:absolute !important;inset:auto auto 0 auto !important;}"
], responsiveMediaQueries.mobile);
var TeamMembersWrapper = styled(Column).withConfig({
    componentId: "sc-1733847e-2"
})([
    "width:100%;overflow:auto;height:225px;&::-webkit-scrollbar{-webkit-appearance:none;height:0;}&::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,0);}"
]);
var TeamMemberRow = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-1733847e-3"
})([
    "padding:",
    ";"
], getSpacing("1x", 0));
var ViewTeamButton = styled(Button).withConfig({
    componentId: "sc-1733847e-4"
})([
    "",
    "{width:100%;}"
], responsiveMediaQueries.mobile);
